<div
    @refresh
    *ngIf="shown"
    class="slide"
    [class.slide--expanded]="spacing === 'expanded'">

    <h1 *ngIf="title" class="slide__title">
        {{ title }}
    </h1>

    <article class="slide__content">
        <ng-content></ng-content>     
    </article>

    <img *ngIf="image" [src]="image" class="slide__image">

    <div class="slide__footer">
        <ng-content select="[slide-footer]"></ng-content>
    </div>
    
</div>
